<template>
  <i v-if="gender === 'female'" class="demo-icon icon-n-female"></i>
  <i v-else-if="gender === 'male'" class="demo-icon icon-n-male"></i>
  <i v-else class="demo-icon icon-n-female"></i>
</template>
<script lang="ts">
export default {
  name: 'GenderIcon',
  components: {},
  props: {
    gender: null,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {

  },
};
</script>